module.exports = __webpack_public_path__ + "static/img/华为XT.22ad7393.png";